import { ACTION_BUTTON_HEIGHT, INPUT_DESKTOP_MAX_WIDTH } from "../../constants/uiConstants";

export const emailFieldRowSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "200px minmax(0, 500px)" },
  alignItems: "center",
  gap: 1.5,
  marginBottom: 2,
  "&:last-of-type": { marginBottom: 0 },
};

export const emailBodyFieldRowSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "200px 1fr" },
  alignItems: { xs: "start", md: "start" },
  gap: 1.5,
  marginBottom: 2,
  "&:last-of-type": { marginBottom: 0 },
};

export const emailFormControlSx = (theme) => ({
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  [theme.breakpoints.up("md")]: { maxWidth: 500 },
});

export const emailCompactFormControlSx = (theme) => ({
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  [theme.breakpoints.up("md")]: { maxWidth: INPUT_DESKTOP_MAX_WIDTH },
});

export const emailFormControlFullWidthSx = {
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
};

export const emailFocusOutlineSx = (primaryColor) => ({
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid rgba(0, 0, 0, 0.42) !important",
  },
  "& .MuiOutlinedInput-root": {
    minHeight: ACTION_BUTTON_HEIGHT,
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: `${primaryColor} !important`,
  },
  "& .MuiOutlinedInput-root.Mui-expanded .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.42) !important",
    borderWidth: "1px",
  },
  "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.Mui-expanded": {
    color: `${primaryColor} !important`,
  },
});

export const emailSectionCardSx = {
  p: 2,
  mt: 1.5,
  boxShadow: 2,
  borderRadius: 1,
};
